import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {httpGetEvents, HttpGetEventsOptions} from '@/features/agenda/http/agenda.http'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'
import {EventSmall} from '@/features/agenda/types'

interface UseGetEventsOptions {
    params: HttpGetEventsOptions['params']
    options?: Omit<UseQueryOptions<EventSmall[], AxiosError<ErrorResponseData>>, 'queryKey' | 'queryFn'>
}

export const useGetEvents = ({params, options}: UseGetEventsOptions) => {
    const {startDate, endDate, therapists, patients, projectId} = params
    return useQuery({
        queryKey: [QUERY_KEYS.AGENDA_EVENTS, {therapists, patients, startDate, endDate, projectId}],
        queryFn: () => httpGetEvents({params}),
        ...options
    })
}
